import { library } from '@fortawesome/fontawesome-svg-core';
import { faCog, faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactElement } from 'react';

library.add(faEye, faCog);

interface IShowHidePasswordIconProps {
  isPasswordVisible: boolean;
  onClick: () => void;
}

export const ShowHidePassword = ({ isPasswordVisible, onClick }: IShowHidePasswordIconProps): ReactElement => (
  <span
    className='password-show-hide'
    onClick={onClick}
  >
    <FontAwesomeIcon
      fixedWidth
      icon={isPasswordVisible ? 'eye' : 'eye-slash'}
      color={isPasswordVisible ? 'primary' : 'neutral'}
    />
  </span>
);
